<template>
  <svg width="12" height="22" viewBox="0 0 12 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.68986 0.31014C1.30886 -0.0708596 0.691139 -0.0708596 0.31014 0.31014C-0.0708596 0.691139 -0.0708596 1.30886 0.31014 1.68986L1.68986 0.31014ZM11 11L11.6899 11.6899C12.0709 11.3089 12.0709 10.6911 11.6899 10.3101L11 11ZM0.31014 20.3101C-0.0708596 20.6911 -0.0708596 21.3089 0.31014 21.6899C0.691139 22.0709 1.30886 22.0709 1.68986 21.6899L0.31014 20.3101ZM0.31014 1.68986L10.3101 11.6899L11.6899 10.3101L1.68986 0.31014L0.31014 1.68986ZM10.3101 10.3101L0.31014 20.3101L1.68986 21.6899L11.6899 11.6899L10.3101 10.3101Z" fill="currentColor"/>
  </svg>
</template>

<script>
  export default {
    name: "NextArrow",
  }
</script>

<style scoped>

</style>